import { approved } from '../content/copy';
import { Accent, Action, Frame, Heading, Icon } from '../components/primitives';
import { ModelStage } from '../components/ModelStage';
import { Navigation } from '../components/Navigation';
import { SiteFooter } from '../components/SiteFooter';
import { track } from '../analytics';

export function Home({ onJoin }: { onJoin: (from: HTMLElement) => void }) {
  return (
    <>
      <section className="intro">
        <Frame className="intro-grid">
          <div className="intro-title">
            <h1 aria-label={approved.title}>
              <span>GET</span>
              <br />
              RRROBLOX
              <br />
              <em className="title-rich">RICH</em>
            </h1>
            <div className="join">
              <Action
                size="nav"
                tone="join"
                className="intro-cta"
                onClick={(event) => {
                  track('join_click', { placement: 'intro' });
                  onJoin(event.currentTarget);
                }}
              >
                <Icon name="play" className="join-icon" />
                Build my money game
              </Action>
              <p className="join-proof">
                <span>
                  <strong>150+</strong> students
                </span>
                <span className="join-dot" aria-hidden="true" />
                <span>
                  <Stars rating={4.8} />
                  <strong>4.8</strong> stars
                </span>
              </p>
            </div>
          </div>
          <div className="intro-model">
            <ModelStage />
          </div>
          <div className="intro-story">
            <div className="story-beat">
              <Heading always>
                Billions
                <br />
                of&nbsp;<Accent>robux</Accent>
              </Heading>
            </div>
            <div className="story-beat">
              <Heading always>
                By millions of <Accent>players</Accent>
              </Heading>
            </div>
            <div className="story-beat">
              <Heading always>
                Playing hundreds of&nbsp;<Accent>games</Accent>
              </Heading>
            </div>
            <div className="story-beat story-beat--last">
              <div className="phrase">
                <div>from</div>
                <div>just</div>
                <div>
                  one<span className="phrase-star">*</span>
                </div>
              </div>
              <div className="reel-heading">
                <Heading reveal={false}>
                  <Accent>guy</Accent>
                </Heading>
              </div>
              <Action
                size="nav"
                tone="join"
                className="outro-cta"
                onClick={(event) => {
                  track('join_click', { placement: 'outro' });
                  onJoin(event.currentTarget);
                }}
              >
                Learn how
                <Icon name="question" className="join-icon" />
              </Action>
            </div>
          </div>
        </Frame>
      </section>
      <Navigation home />
      <SiteFooter className="legal-footer--phone" />
    </>
  );
}

const STAR = 'M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4l-5.9 3.1 1.2-6.5-4.8-4.6 6.6-.9Z';

/* Gold stars in the page's outline style; the last one fills to the fraction. */
function Stars({ rating }: { rating: number }) {
  return (
    <svg className="join-stars" viewBox="0 0 120 24" aria-hidden="true">
      <defs>
        <clipPath id="star-fill">
          <rect width={rating * 24} height="24" />
        </clipPath>
      </defs>
      {[0, 1, 2, 3, 4].map((index) => (
        <g key={index} transform={`translate(${index * 24})`}>
          <path d={STAR} className="join-star-empty" />
        </g>
      ))}
      <g clipPath="url(#star-fill)">
        {[0, 1, 2, 3, 4].map((index) => (
          <path key={index} d={STAR} transform={`translate(${index * 24})`} className="join-star" />
        ))}
      </g>
      {[0, 1, 2, 3, 4].map((index) => (
        <path
          key={index}
          d={STAR}
          transform={`translate(${index * 24})`}
          className="join-star-line"
        />
      ))}
    </svg>
  );
}
